import { APP_META_TRAVEL_ADS_API_ENDPOINT } from "constants/api_urls";
import axios from "axios";
import { getUserToken } from "utils/functions/userToken";

/**
 * Fetches hotel catalog data (image URL, website URL, name, description) from the API.
 *
 * Endpoint: GET /api/meta-ads/catalog/hotel-data/{hotelId}
 *
 * @param {string|number} hotelId - The hotel ID
 * @returns {Promise<{success: boolean, imageUrl?: string, websiteUrl?: string, hotelName?: string, description?: string, data?: object, error?: string}>}
 */
export const getHotelCatalogData = async (hotelId) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.get(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/catalog/hotel-data/${hotelId}`,
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        const imageUrl = response.data?.image_url || null;
        const websiteUrl = response.data?.url || null;
        const hotelName = response.data?.name || null;
        const description = response.data?.description || null;
        return { success: true, imageUrl, websiteUrl, hotelName, description, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.errorMessage || "Failed to fetch hotel catalog data";
        return { success: false, error: errorMessage };
    }
};
